import { Controller } from "@hotwired/stimulus"
import { MeiliSearch } from "meilisearch"
import L from "leaflet"

// Leaflet map with MeiliSearch geo search for marketplace items
// Values: bbox (Array), query, searchParams (Object)
// Targets: map, searchOnMove
export default class extends Controller {
  static values = { bbox: Array, query: String, searchParams: Object }
  static targets = ["map", "searchOnMove"]

  connect() {
    const env = document.querySelector('meta[name=env]')?.content || 'development'
    const client = new MeiliSearch({ host: location.protocol + '//' + location.host })
    this.itemsIndex = client.index('Marketplace_Item_' + env)
    this.searchOnMove = true
    this.markers = null

    this.initMap()
    this.search()

    this.handleMove = this.handleMove.bind(this)
    this.mymap.on("moveend", this.handleMove)

    document.addEventListener("turbo:load", () => {
      if (window._turboScroll) {
        document.scrollingElement.scrollTo(0, window._turboScroll)
      }
      window._turboScroll = 0
    })
  }

  disconnect() {
    if (this.mymap) {
      this.mymap.off("moveend", this.handleMove)
      this.mymap.remove()
    }
  }

  initMap() {
    const bbox = this.bboxValue

    if (bbox && bbox.length >= 5) {
      this.mymap = L.map(this.mapTarget).fitBounds([
        [bbox[0], bbox[1]],
        [bbox[2], bbox[3]]
      ]).setZoom(bbox[4])
    } else {
      this.mymap = L.map(this.mapTarget).setView([30, -10], 2)
    }

    L.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGVybWFwZW9wbGUiLCJhIjoiY2xndjg5empjMDE3bDNrcGxqazN4eWQxYiJ9.TTzaA931zw2NhANr-tXuuA", {
      minZoom: 2,
      maxZoom: 18,
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>',
      id: "mapbox/streets-v11",
      tileSize: 512,
      zoomOffset: -1
    }).addTo(this.mymap)

    this.markers = L.layerGroup()
    this.mymap.addLayer(this.markers)
  }

  toggleSearchOnMove(event) {
    this.searchOnMove = event.target.checked
  }

  handleMove() {
    const bounds = this.mymap.getBounds()
    const zoom = this.mymap.getZoom()
    const bbox = [
      bounds.getNorthWest().lat,
      bounds.getNorthWest().lng,
      bounds.getSouthEast().lat,
      bounds.getSouthEast().lng,
      zoom
    ]

    this.bboxValue = bbox

    if (this.searchOnMove) {
      let loc = window.location.toString()

      if (/bbox=[^&]*/.test(window.location.search)) {
        loc = loc.replace(/bbox=[^&]*/, "bbox=" + bbox.join(","))
      } else {
        const separator = window.location.search ? "&" : "?"
        loc = window.location + separator + "bbox=" + bbox.join(",")
      }

      window._turboScroll = document.scrollingElement.scrollTop
      Turbo.visit(loc)
      this.search()
    }
  }

  search() {
    const params = Object.assign({}, this.searchParamsValue || {})
    params.hitsPerPage = 2000

    const bbox = this.bboxValue
    if (bbox && bbox.length >= 4) {
      const clamped = bbox.slice(0, 4).map(x => Math.min(Math.max(x, -180.0), 180.0))
      params.filter = "_geoBoundingBox([" + clamped[0] + "," + clamped[3] + "],[" + clamped[2] + "," + clamped[1] + "])"
    }

    this.itemsIndex.search(this.queryValue || "", params).then((result) => {
      this.updateMap(result.hits)
    })
  }

  updateMap(items) {
    this.markers.clearLayers()
    items.forEach(item => {
      if (item._geo) {
        this.markers.addLayer(
          L.marker([item._geo.lat, item._geo.lng])
            .bindPopup(
              "<div class='map-popup'><div class='map-popup-content'><label class='map-popup-title'>" +
              item.seller +
              "</label></div><a class='map-popup-btn' href='/marketplace?seller=" +
              item.seller +
              "'>View seller</a></div>"
            )
        )
      }
    })
  }
}
